var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcdConnectEmoji1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 178,
    viewBox: "0 0 177 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.24 167.038C131.45 167.038 166.48 132.008 166.48 88.7981C166.48 45.5881 131.45 10.5581 88.24 10.5581C45.03 10.5581 10 45.5881 10 88.7981C10 132.008 45.03 167.038 88.24 167.038Z",
    fill: "#83BB26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.51 75.3981C56.51 83.9981 49.54 90.9781 40.93 90.9781C32.32 90.9781 25.35 84.0081 25.35 75.3981C25.35 66.7881 32.33 59.8181 40.93 59.8181C49.53 59.8181 56.51 66.7981 56.51 75.3981Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4799 69.3681C40.4799 71.8981 38.4299 73.9481 35.8999 73.9481C33.3699 73.9481 31.3199 71.8981 31.3199 69.3681C31.3199 66.8381 33.3699 64.7881 35.8999 64.7881C38.4299 64.7881 40.4799 66.8381 40.4799 69.3681Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 76.588C45.5 78.048 44.32 79.228 42.86 79.228C41.4 79.228 40.22 78.048 40.22 76.588C40.22 75.128 41.4 73.948 42.86 73.948C44.32 73.948 45.5 75.128 45.5 76.588Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.12 75.3981C151.12 83.9981 144.14 90.9781 135.54 90.9781C126.94 90.9781 119.96 84.0081 119.96 75.3981C119.96 66.7881 126.94 59.8181 135.54 59.8181C144.14 59.8181 151.12 66.7981 151.12 75.3981Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.08 69.3681C135.08 71.8981 133.03 73.9481 130.5 73.9481C127.97 73.9481 125.92 71.8981 125.92 69.3681C125.92 66.8381 127.97 64.7881 130.5 64.7881C133.03 64.7881 135.08 66.8381 135.08 69.3681Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.1 76.588C140.1 78.048 138.92 79.228 137.46 79.228C136 79.228 134.82 78.048 134.82 76.588C134.82 75.128 136 73.948 137.46 73.948C138.92 73.948 140.1 75.128 140.1 76.588Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56 99.518C103.99 107.328 96.7 112.698 88.5 112.908C80.32 113.118 72.68 107.838 69.89 100.168C69.44 98.928 68.26 98.098 66.9 98.468C65.7 98.798 64.75 100.208 65.2 101.458C68.77 111.268 78.01 117.858 88.49 117.768C98.89 117.678 108.03 110.578 111.24 100.808C112.22 97.818 107.53 96.548 106.55 99.518",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.12 104.258C52.12 108.638 47.35 112.188 41.46 112.188C35.57 112.188 30.79 108.638 30.79 104.258C30.79 99.8781 35.57 96.3281 41.46 96.3281C47.35 96.3281 52.12 99.8781 52.12 104.258Z",
    fill: "#FFD525"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.68 104.258C145.68 108.638 140.91 112.188 135.02 112.188C129.13 112.188 124.35 108.638 124.35 104.258C124.35 99.8781 129.13 96.3281 135.02 96.3281C140.91 96.3281 145.68 99.8781 145.68 104.258Z",
    fill: "#FFD525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcdConnectEmoji1);
export default __webpack_public_path__ + "static/media/ECD_Connect_emoji1.9e5e56f0.svg";
export { ForwardRef as ReactComponent };